import React from 'react';
import { useReportWindows } from './ReportWindowsContext';
import ReportPopup from './ReportPopup';

/**
 * Renders one ReportPopup per open report window. Each ReportPopup portals its own
 * content into its OS popup, so this layer renders no visible DOM in the main tab
 * and needs no taskbar (the OS manages the windows). Mounted once at app root.
 */
const ReportWindowLayer = () => {
  const { windows } = useReportWindows();
  return (
    <>
      {windows.map((w) => (
        <ReportPopup key={w.id} win={w} />
      ))}
    </>
  );
};

export default ReportWindowLayer;
